var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"background":"#f0f2f5","margin-top":"-20px","height":"100%"}},[_c('div',{staticClass:"wscn-http404"})])
}]

export { render, staticRenderFns }